import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { LoaderService } from './loader.service';

export const localLoaderUrls = ['/v1/provider/authentication/login'];

export const loaderInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn,
): Observable<HttpEvent<any>> => {
  const apisToBeSkipped: string[] = [
    'partner-availability',
    'filters',
    'driver-map-ride',
    'server-timezone',
    'avatar',
    'statistics',
    'equipment-files',
    'arrival-time-report/blueprints',
  ];

  // Skip loader for notify compliance tracker endpoint (pattern: /compliance/{stakeholderType}/{vehicleId})
  const complianceTrackerPattern = /\/compliance\/\d+\/\d+$/;
  const isNotifyComplianceTracker =
    complianceTrackerPattern.exec(req.url) !== null;

  const loaderService = inject(LoaderService);

  let isLocalLoader = localLoaderUrls.some(url => req.url.includes(url));

  if (
    !isLocalLoader &&
    apisToBeSkipped.every(a => !req.url.includes(a)) &&
    !isNotifyComplianceTracker
  )
    loaderService.show();
  else loaderService.showLocal();

  return next(req).pipe(
    catchError(error => {
      if (
        !isLocalLoader &&
        apisToBeSkipped.every(a => !req.url.includes(a)) &&
        !isNotifyComplianceTracker
      )
        loaderService.hide();
      else loaderService.hideLocal();
      throw error;
    }),
    finalize(() => {
      if (
        !isLocalLoader &&
        apisToBeSkipped.every(a => !req.url.includes(a)) &&
        !isNotifyComplianceTracker
      )
        loaderService.hide();
      else loaderService.hideLocal();
    }),
  );
};
